import { TravelCardsDto, UpdateTravelCardDto, TravelCardOrderDetailsDto, TravelCardDto } from '../types';
import { ITravelCardApi } from './Interface/ITravelCardApi';
import { ApiService } from '@/services/ApiService';
import { ax } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export default class TravelCardApi extends ApiService implements ITravelCardApi {
    async getTravelCards(take?: number): Promise<TravelCardsDto | undefined> {
        return await this.httpGet<TravelCardsDto | undefined>(`/api/fort/profiles/me/travel-cards?take=${take}`);
    }

    async createTravelCard(name: string, number: string): Promise<AxiosResponse<TravelCardDto>> {
        return await ax.post<AxiosResponse, any>(`/api/fort/profiles/me/travel-cards`, { name, number });
    }

    async blockTravelCard(id: string): Promise<void> {
        return await this.httpPut<void>(`/api/fort/profiles/me/travel-cards/${id}/block`);
    }

    async updateTravelCard(id: string, name: string): Promise<UpdateTravelCardDto | undefined> {
        return await this.httpPut<UpdateTravelCardDto>(`/api/fort/profiles/me/travel-cards/${id}`, { name, id });
    }

    async deleteTravelCard(id: string): Promise<void> {
        return await this.httpDelete<void>(`/api/fort/profiles/me/travel-cards/${id}`);
    }

    async getMultipleTravelCardData(cardNumbers: string, language: string): Promise<TravelCardOrderDetailsDto[] | undefined> {
        return await this.httpGet<TravelCardOrderDetailsDto[]>(
            `/api/webshop/v1.0/travelcards/batch?cardNumbers=${cardNumbers}&cache=true`,
            {
                headers: { 'accept-language': language }
            }
        );
    }

    async validateTravelCardNumber(cardNumber: string): Promise<boolean> {
        const response = await ax.get<number | undefined>(`/api/webshop/v1.0/travelcards/${cardNumber}/validate`);
        return response.data !== undefined && typeof response.data === 'number';
    }
}
